import { IMeasurement } from 'types';
import { updateDocument } from 'utils/firebase';
import { COLLECTIONS } from 'constants/collections';

export const update = ({ id, values }: IMeasurement) => {
  return updateDocument({
    id,
    data: { values },
    collection: COLLECTIONS.MEASUREMENTS,
  });
};
